import { UserApi } from "./MDSL/user.api";

// Context exports
export {
  ApiContext,
  ApiProvider,
  MdslApiProvider,
  type ApiContextValue,
  type ApiContextType,
} from "./context";

// Hook exports
export { useApiContext, useDataApi, useWeatherApi } from "./context/hooks";

// Shared type exports
export * from "./shared/types";

// API Client export
export { apiClient, default as defaultApiClient } from "./apiClient";
export type { CustomAxiosDefaults } from "./apiClient";

// Query exports
export * from "./queries";

// API exports
export { NetworkApi } from "./MDSL/network.api";
export { UserApi } from "./MDSL/user.api";
export * from "./MDSL/queries";


export { WeatherApi } from "./Weather/weather.api";

export const userApi = UserApi.getInstance();
